import { message } from "antd";

export const useMessage = ( ) => message.useMessage();